import { render, staticRenderFns } from "./VirtualServerPackagePrices.vue?vue&type=template&id=141bc037&"
import script from "./VirtualServerPackagePrices.vue?vue&type=script&lang=js&"
export * from "./VirtualServerPackagePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports